import React from "react";

function UpArrow() {
    return (
        <svg
            id="expand_more_black_24dp_3_"
            data-name="expand_more_black_24dp (3)"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <path id="Path_205978" data-name="Path 205978" d="M24,24H0V0H24Z" fill="none" opacity="0.87" />
            <path id="Path_205979" data-name="Path 205979" d="M16.59,8.59,12,13.17,7.41,8.59,6,10l6,6,6-6Z" fill="#1a1a1a" />
        </svg>
    );
}

export default UpArrow;
